<template>
  <layout-div>
    <div class="row justify-content-md-center full-screen-bg">
      <div class="col-12">
        <nav class="navbar navbar-expand-lg">
          <div class="container-fluid mt-1">
            <div class="navbar-brand-box text-center" @click="$router.push('/')">
              <img src="@/assets/Logo_pro.png" alt="Logo" style="width: 120px; height: auto;" />
            </div>
            <div class="text-end">
              <div class="time-tracking-container">
                <div class="dropdown-container">
                  <div class="dropdown">
                    <a class="nav-link dropdown-toggle text-capitalize" id="dropdownMenuButton" role="button"
                      data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false"
                      style="color: white; font-size: 15px;">
                      {{ fullname }}
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end text-center" aria-labelledby="dropdownMenuButton">
                      <li><a class="dropdown-item" href="#" @click="$router.push('/profile')">Profil</a></li>
                      <hr>
                      <li><a class="dropdown-item" href="#" @click="logout">Abmelden</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>

        <hr style="border-top: 2px solid rgb(120, 132, 136);" class="mt-0">
        <div class="container p-4" style="background-color: #121738;">
          <div class="time-tracking-container" style="text-align: center;">
            <div class="button-container">
              <p class="timer-info" style="font-size: 44px; color: white;">
                <span>{{ elapsedTime.split(':')[0] }}</span>:<span>{{ elapsedTime.split(':')[1] }}</span>:<span
                  style="color: rgb(103, 87, 196);">{{ elapsedTime.split(':')[2] }}</span>
                <button type="button" @click="refresh" class="btn btn-outline-primary ms-4"
                  style="color: white; font-weight: bold; margin-top: -6px;">
                  <i class="bi bi-arrow-clockwise"></i>
                </button>
              </p>
              <button type="button" @click="timeRecord(timerRunning ? 'Work' : 'Break')"
                class="btn btn-outline-success me-4"
                :disabled="!canTrack"
                style="background-color: #28a745; color: white; font-weight: bold;">
                <i v-if="timerRunning" class="bi bi-play-circle"></i>
                <i v-else class="bi bi-cup-hot"></i>
                {{ timerRunning ? 'Arbeit' : 'Pause' }}
              </button>
              <button type="button" @click="timeRecord('Offline')" class="btn btn-outline-danger"
                :disabled="timerRunning || !canTrack"
                style="background-color: #dc3545; color: white; font-weight: bold;">
                <i class="bi bi-box-arrow-right me-1"></i>Ende
              </button>
              <div v-if="!loading && !canTrack" class="widget-locked-msg">
                <i class="bi bi-exclamation-triangle me-2"></i>Die Zeiterfassung läuft bereits im JobRouter-Widget.
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center mt-2 mb-1">
          <div class="col-12 col-md-6">
            <div class="card entry-card customcard">
              <div class="card-body">
                <template v-if="loading">
                  <div class="text-center">
                    <div class="spinner-border text-dark" role="status"></div>
                  </div>
                </template>
                <template v-else>
                  <div class="entry-item p-2" style="border-radius: 10px;">
                    <div class="d-flex ms-1">
                      <div class="col-4 text-start">
                        <strong style="font-size: 18px;">Heute</strong>
                      </div>
                      <div class="col-4 text-end"><strong style="font-size: 17px;" class=""><i
                            class="bi bi-play-circle me-2 text-success"></i><span class="">{{
                              secondsInTimeFormat(workTotal) }}</span></strong></div>
                      <div class="col-4 text-end"><strong style="font-size: 17px;"><i
                            class="bi bi-cup-hot me-2 text-warning"></i><span class="">{{
                              secondsInTimeFormat(breakTotal) }}</span></strong></div>
                    </div>
                  </div>
                  <div class="scrollable-entries" style="max-height: var(--hex-parent-height) ; overflow-y: auto;">
                    <div v-for="(entry, index) in entries.slice().reverse()" :key="index" class="entry-item mt-3 p-3"
                      style="background-color: #f0f0f0; border-radius: 10px;">
                      <div class="d-flex">
                        <div class="col-4 text-start">
                          <strong>{{ entry.type == 'Work' ? 'Arbeit': (entry.type == 'Break' ? 'Pause': 'Offline') }}</strong>
                        </div>
                        <div class="col-4 text-end">{{ formatTime(entry.start_time) }}</div>
                        <div class="col-4 text-end" v-if="entry.end_time">{{ formatTime(entry.end_time) }}</div>
                        <div class="col-4 text-end" v-else>
                          <span class="custom-badge">Aktuell</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="!loading && entries.length === 0">
                  <div class="text-center noentry">
                    <strong>noch keine Daten erfasst</strong>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout-div>
</template>

<script>
import axios from 'axios';
import tokenService from '@/tokenService';
import LayoutDiv from './LayoutDiv.vue';
import $ from 'jquery';
import moment from 'moment';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { API_BASE_URL, API_WIDGET } from '../config';
import { onMounted, ref } from "vue";
import { Dropdown } from "bootstrap";

export default {
  name: 'TimeTracking',
  components: {
    LayoutDiv,
  },
  setup() {
    onMounted(() => {
      const dropdownElement = document.querySelector(".dropdown-toggle");
      if (dropdownElement) {
        new Dropdown(dropdownElement);
      }
    });
  },
  data() {
    return {
      timerRunning: true,
      elapsedTime: "00:00:00",
      timerInterval: null,
      trackingType: "Work",
      startTime: 0,
      timerAlreadyStopped: false,
      name: '',
      entries: [],
      loading: true,
      screenHeight: null,
      fullname: '',
      workTotal: 0,
      breakTotal: 0,
      canTrack: false
    };
  },
  async created() {
    this.timerRunning = true,
      this.elapsedTime = "00:00:00"
    this.timerAlreadyStopped = false
    await this.timeTrackingDetailsAPI();
    // document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  computed: {
    computedElapsedTime() {
      return Math.floor((Date.now() - this.startTime) / 1000);
    },
  },
  methods: {
    async timeTrackingDetailsAPI() {
      const storedUsername = tokenService.getStoredUsername();
      this.name = tokenService.getStoredUsername() ?? '';
      let foundNullEndTime = false;
      const context = this
      await $.ajax({
        type: "POST",
        url: `${API_BASE_URL}/${API_WIDGET}/UserTimeRecord/timeRecord.php`,
        data: { action: 'getUserDetails', username: storedUsername },
        success: function (response) {
          response = JSON.parse(response);
          localStorage.setItem('entries', JSON.stringify(response.data));
          localStorage.setItem('fullname', response.username);
          if (!response?.username) {
            const $toast = useToast();
            $toast.open({
              message: `Es ist ein Fehler aufgetreten. Bitte kontaktieren Sie das Support-Team für weitere Hilfe.`,
              type: 'error',
              position: 'top-right'
            });
            context.logout();
          }
          context.fullname = response.username
          context.canTrack = response.canTrack === true
          var tracks = JSON.parse(localStorage.getItem('entries'))
          const workEntries = tracks.filter((e) => e.type !== 'Offline');
          context.entries = workEntries
          context.loading = false
          if (tracks.length >= 1) {
            context.updateWorkAndBreakTotals(tracks)
            for (let i = tracks.length - 1; i >= 0; i--) {
              const track = tracks[i]
              const endTime = track.end_time
              if (!endTime) {
                foundNullEndTime = true
                context.handleNullEntry(track)
                context.trackingType = track.type
                break
              } else if (foundNullEndTime) {
                // console.log(`End time is not null for track ${i}`);
              }

              if (!foundNullEndTime) {
                context.timerAlreadyStopped = true
              }
            }
          } else {
            context.timerAlreadyStopped = true
          }
          // console.log(context.timerAlreadyStopped);
        }
      });
    },
    async updateWorkAndBreakTotals(tracks) {
      let workTotal = 0;
      let breakTotal = 0;
      for (const entry of tracks) {
        if (entry.type === 'Work') {
          workTotal = entry.totalSeconds;
        } else if (entry.type === 'Break') {
          breakTotal = entry.totalSeconds;
        }
      }
      this.workTotal = workTotal;
      this.breakTotal = breakTotal;
    },

    async handleNullEntry(entry) {
      if (entry.type != 'Offline') {
        localStorage.setItem('lastEntry', JSON.stringify(entry))
        this.timerRunning = (entry.type == 'Work' ? false : true)
        const lastEntry = entry;
        const lastStartTime = new Date(lastEntry.start_time);
        const currentTime = new Date();
        const difference = currentTime - lastStartTime;

        const totalSeconds = Math.floor(difference / 1000) + lastEntry.totalSeconds;

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const formattedTotalTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        this.startTimerWithTime(formattedTotalTime);
      } else {
        this.timerRunning = true
        // clearInterval(this.timerInterval);
        cancelAnimationFrame(this.timerInterval);
        this.elapsedTime = "00:00:00"
      }
    },

    startTimerWithTime(formattedTotalTime) {
      this.elapsedTime = formattedTotalTime;
      let [hours, minutes, seconds] = this.elapsedTime.split(":").map(Number);
      const totalSeconds = hours * 3600 + minutes * 60 + seconds;

      const now = Date.now();
      this.startTime = now - totalSeconds * 1000;

      const updateTimer = () => {
        const elapsedMilliseconds = Date.now() - this.startTime;

        const elapsedHours = Math.floor(elapsedMilliseconds / 3600000);
        const elapsedMinutes = Math.floor((elapsedMilliseconds % 3600000) / 60000);
        const elapsedSeconds = Math.floor((elapsedMilliseconds % 60000) / 1000);

        this.elapsedTime = `${elapsedHours.toString().padStart(2, '0')}:${elapsedMinutes.toString().padStart(2, '0')}:${elapsedSeconds.toString().padStart(2, '0')}`;

        this.timerInterval = requestAnimationFrame(updateTimer);
      };

      cancelAnimationFrame(this.timerInterval);
      this.timerInterval = requestAnimationFrame(updateTimer);
    },

    handleVisibilityChange() {
      if (!document.hidden && this.timerRunning) {
        const elapsedMilliseconds = Date.now() - this.startTime;

        const elapsedHours = Math.floor(elapsedMilliseconds / 3600000);
        const elapsedMinutes = Math.floor((elapsedMilliseconds % 3600000) / 60000);
        const elapsedSeconds = Math.floor((elapsedMilliseconds % 60000) / 1000);

        this.elapsedTime = `${elapsedHours.toString().padStart(2, '0')}:${elapsedMinutes.toString().padStart(2, '0')}:${elapsedSeconds.toString().padStart(2, '0')}`;
        this.startTimerWithTime(this.elapsedTime);
      }
    },

    secondsInTimeFormat(totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },

    dateTimeFormat(date) {
      return moment(date).format('L HH:mm:ss')
    },

    formatTime(dateTimeString) {
      const date = new Date(dateTimeString)
      const hours = date.getHours().toString().padStart(2, "0")
      const minutes = date.getMinutes().toString().padStart(2, "0")
      const seconds = date.getSeconds().toString().padStart(2, "0")

      return `${hours}:${minutes}:${seconds}`;
    },

    async timeRecord(status) {
      if (!this.canTrack) return;
      const storedUsername = tokenService.getStoredUsername();
      const context = this
      this.loading = true
      $.ajax({
        type: "POST",
        url: `${API_BASE_URL}/${API_WIDGET}/UserTimeRecord/timeRecord.php`,
        data: { action: "newUserRecordInsert", username: storedUsername, date: this.dateTimeFormat(new Date()), type: status, end_date: this.dateTimeFormat(new Date()), date_ISO: new Date().toISOString(), end_date_ISO: new Date().toISOString() },
        success: function (response) {
          response = JSON.parse(response);
          context.canTrack = response.canTrack === true
          localStorage.setItem('entries', JSON.stringify(response.data));
          var tracks = JSON.parse(localStorage.getItem('entries'))
          context.updateWorkAndBreakTotals(tracks)
          const workEntries = tracks.filter((e) => e.type !== 'Offline');
          context.entries = workEntries
          context.loading = false
          const lastentry = tracks[tracks.length - 1]
          context.handleNullEntry(lastentry)
        }
      });

    },

    refresh() {
      location.reload();
    },
    async logout() {
      tokenService.clearToken();
      this.$router.push('/login');
    },
  },
};
</script>
<style scoped>
.navbar-brand-box {
  display: inline-block;
  padding: 2px;
  border: 0 solid rgb(99, 149, 173);
  border-radius: 5px;
}

.customcard {
  background-color: #ffffff;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  left: 0;
  position: absolute;
  min-height: 100%;
  z-index: 12;
  width: 100%;
}

.navbar-brand {
  color: white;
  text-decoration: none;
}

.nav-link {
  color: white;
  text-decoration: none;
}

.dropdown-menu {
  background-color: #4c5382;
}

.dropdown-item {
  color: white;
}

.container {
  flex: 1;
  background-color: #121738;
}

hr {
  border-top: 2px solid lightblue;
}

.timer-info {
  font-size: 24px;
  color: white;
}

.noentry {
  margin-top: 20%;
}

.btn-outline-success {
  background-color: #28a745;
  color: white;
  font-weight: bold;
}

.btn-danger-background {
  background-color: #dc3545;
  color: white;
  font-weight: bold;
}

.btn-primary-background {
  background-color: #007bff;
  color: white;
  font-weight: bold;
}

.widget-locked-msg {
  margin-top: 16px;
  padding: 10px 16px;
  background-color: #fdecea;
  color: #b71c1c;
  border: 1px solid #f5c2c0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
}

.custom-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  background-color: #28a745;
  color: #fff;
}

@media (max-width: 767px) {

  body,
  html {
    background-color: #121738;
  }
}

body,
html {
  height: 100%;
  margin: 0;
  padding: 0;
}

.dropdown-menu.poper.text-center.show {
  position: absolute;
  left: 0%;
}

.full-screen-bg {
  background-color: #121738;
  height: 100vh;
}

.dropdown-menu :hover {
  background-color: transparent !important;
  color: white;
}

.dropdown-container {
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
  position: relative;
}

.dropdown-menu {
  position: absolute !important;
  min-width: 150px;
  max-width: 90vw;
  white-space: nowrap;
  z-index: 1050;
}

.dropdown-menu-end {
  right: 0 !important;
  left: auto !important;
}

@media (max-width: 768px) {
  .dropdown-menu {
    transform: translateX(-50%) !important;
    left: 50% !important;
    right: auto !important;
  }
}
</style>
